<template>
  <li :class="[isFolder ? 'folder' : 'file']">
    <label v-if="this.model.type !== 2"
      :class="{'open': open || (this.model.need_open && this.model.need_open === true )  }"
      @click.self="toggle"
      >
      <div class="row">
        <div class="col-md-12 category-row">
            <div class="col-md-1">
              <span class="model-id" @click.self="toggle">{{model.identifier}}</span>
            </div>
            <div class="col-md-2">
              <span v-if="model.name" class="model-name" @click.self="toggle">{{model.name}}</span>
            </div>
        </div>
      </div>
      <i v-if="model.type === 2 && needAction === true" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>
      <i v-if="model.type === 2 && needAction === true" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>

    </label>
    <label v-else
      :class="{'open': open || (this.model.need_open && this.model.need_open === true )  }"
      @click.self="toggle"
      >
      <div class="row">
        <div class="col-md-12 statement-row">
          <div class="col-md-1">
          </div>
          <div class="col-md-1">
          </div>
          <div class="col-md-2">
            <span class="model-id">{{model.identifier}}</span>
          </div>
          <div class="col-md-3">
            <span v-if="model.statement" class="model-name">{{model.statement}}</span>
          </div>
          <div class="col-md-3">
            <span v-if="model.verification_question_name" class="model-name" @click.self="toggle">{{model.verification_question_name}}</span>
          </div>
          <div class="col-md-2 location-col">
            <span class="array-span" v-for="(location,index) in model.locations" :key="index">{{location}}</span>
          </div>
          <div class="col-md-1 action-row">
            <v-popover :trigger="'hover'">
                <i v-if="model.type === 2" :class="this.model.has_legal_description === true ? 'paragraph extra-icon active' : 'paragraph extra-icon'"></i>
                <template slot="popover">
                  <legal-info-popup
                    :data="model.legal_description"/>
                </template>
            </v-popover>
            <v-popover :trigger="'hover'">
                <i
                  :class="`ti-info active`"
                ></i>
                <template slot="popover">
                  <info-popup
                    :data="{created_at: this.model.created_at,updated_at: this.model.updated_at}"/>
                </template>
            </v-popover>
            <i v-if="model.type === 2 && needAction === true && ableToEdit(model.specializations)" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>
            <i v-else-if="model.type != 2 && needAction === true" @click="editItem('edit')" class="zmdi zmdi-edit action-button"></i>
            <i v-if="model.type === 2 && needAction === true && ableToEdit(model.specializations)" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>
            <i v-else-if="model.type != 2 && needAction === true" @click="deleteItem" class="zmdi zmdi-delete action-button"></i>

          </div>
        </div>
      </div>
    </label>
    <ul v-show="open || (this.model.need_open && this.model.need_open === true )" v-if="isFolder" :class="{'open': open}">
      <item
        v-for="(model, index) in model.children"
        :key="index"
        :selectedIndex="index"
        :parentIndex="selectedIndex"
        :bus="bus"
        :isSearch="isSearch"
        :needAction="needAction"
        :model="model"/>
    </ul>
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GenericForm from '@/components/shared/forms/GenericForm';
import LegalInfoPopUp from '@/components/modules/base_states/LegalInfoPopUp';
import InfoPopUp from '@/components/modules/base_states/InfoPopUp';

export default {
  name: 'item',
  components: {
    'info-popup': InfoPopUp,
    'legal-info-popup': LegalInfoPopUp,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    bus: {
      type: Object,
      required: false,
    },
    selectedIndex: {
      type: Number,
      required: false,
    },
    parentIndex: {
      type: Number,
      required: false,
    },
    isSearch: {
      type: Boolean,
      required: false,
    },
    needAction: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      open: false,
      allVerificationQuestions: [],
    };
  },
  created() {
  },
  computed: {
    ...mapGetters({
      allStatement: 'statements/allStatements',
      allCriteriaCategories: 'criteriaCategories/allCriteriaCategories',
      storedStatement: 'statements/selectedStatement',
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    isFolder() {
      return this.model.children && this.model.children.length || this.model.type === 0 || this.model.type === 1;
    },
    statementAttributes() {
      return [
        {
          name: 'statement',
          type: 'text',
          classes: 'col-md-12',
        },
        {
          name: 'criteria_category_id',
          type: 'dropdown',
          action: 'selectCategory',
          dropdownList: this.categoriesForList,
          classes: 'col-md-6',
        },
        {
          name: 'sub_criteria_category_id',
          type: 'dropdown',
          action: 'selectSubCategory',
          dropdownList: this.subCategoriesForList,
          classes: 'col-md-6',
        },
        {
          name: 'verification_question_id',
          type: 'dropdown',
          dropdownList: this.questionsForList,
          classes: 'col-md-6',
        },
        {
          name: 'locations',
          type: 'tag',
          list: this.locationsForList,
        },
      ];
    },
    questionsForList() {
      if (this.allVerificationQuestions) {
        const mappedQuestions = this.allVerificationQuestions.map(question => ({
          value: question.id,
          text: question.name,
        }));
        return mappedQuestions;
      }
      return [];
    },
    categoriesForList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id === null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
    subCategoriesForList() {
      if (!this.commonData || !this.commonData.criteria_category_list) {
        return [];
      }
      const mappedCategories = this.commonData.criteria_category_list.filter(category => category.parent_id !== null).map(
        category => ({
          value: category.id,
          text: category.name,
        }),
      );
      return mappedCategories;
    },
    locationsForList() {
      const siteList = this.commonData.location_list.map((location) => {
        if (location.site_id === this.model.site_id) {
          return { id: location.id, text: location.name }
        };
      });
      return siteList.filter(x => x !== undefined);
    },
  },
  methods: {
    ...mapActions({
      deleteStatement: 'statements/deleteStatement',
      fetchStatement: 'statements/fetchStatement',
      updateStatementParams: 'statements/updateStatement',
      fetchVerificationQuestions:
        'verificationQuestions/fetchVerificationQuestions',
      fetchCriteriaCategory: 'criteriaCategories/fetchCriteriaCategory',
    }),
    ableToEdit(specializations) {
      const userSpecIds = this.loggedInUser.specializations.map(spec => spec.id);
      return userSpecIds.some(id => specializations.includes(id));
    },
    toggle() {
      if (this.isFolder) {
        if (this.model.need_open) {
          this.model.need_open = false;
          this.open = false;
        } else {
          this.open = !this.open;
        }
      }
      if (this.model.type === 0 && !this.isSearch) {
        this.bus.$emit('getChild', this.model.id, this.selectedIndex);
      }
    },
    changeType() {
      if (!this.isFolder) {
        this.set(this.model, 'children', []);
        this.addChild();
        this.open = true;
      }
    },
    deleteItem() {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            this.deleteStatement(this.model.id)
              .then((response) => {
                this.$eventBus.showNotification({
                  notificationText: this.$t('app.statements.success.delete'),
                  notificationType: 'success',
                });
                if (this.model.for_main_category === true) {
                  this.bus.$emit('deleteStatement', this.parentIndex, this.selectedIndex);
                } else {
                  this.bus.$emit('deleteStatementForSub', this.model.main_idx, this.parentIndex, this.selectedIndex);
                }
              })
              .catch((error) => {
                const errorMessage = error && error.length > 0 ? error[0] : this.$t('app.statements.errors.deletion_error')
                this.$swal
                  .fire({
                    html: errorMessage,
                    type: 'error',
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                  });
              });
          }
        });
    },
    editItem(action) {
      this.fetchStatement(this.model.id).then((statement) => {
        this.fetchVerificationQuestions({
          criteriaCategoryId: statement.criteria_category_id,
          limited: true,
          self_id: statement.verification_question_id,
        }).then((questions) => {
          this.allVerificationQuestions = questions;
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.$t('app.statements.edit_statement'),
              fields: this.statementAttributes,
              model: statement,
              submitTitle: this.$t('app.statements.buttons.save'),
              cancelTitle: this.$t('app.statements.buttons.cancel'),
              modelName: 'statements',
              hasMultipleColumn: true,
            },
            on: {
              sendAction: this.sendUpdateAction,
              submit: this.updateStatement,
            },
            width: '1000px',
          });
        });
      });
    },
    updateStatement(statement) {
      this.updateStatementParams(statement)
        .then((response) => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.statements.success.update'),
            notificationType: 'success',
          });
          const newStatement = {
            statement: response.statement,
            verification_question_name: response.verification_question_name,
            verification_question_id: response.verification_question_id,
          };
          if (this.model.for_main_category === true) {
            this.bus.$emit('getChild', this.model.criteria_category_id, this.parentIndex);
            this.bus.$emit('updateStatement', this.parentIndex, this.selectedIndex, newStatement);
          } else {
            this.bus.$emit('getChild', this.model.parent_category_id, this.model.main_idx);
            this.bus.$emit('updateStatementForSub', this.model.main_idx, this.parentIndex, this.selectedIndex, newStatement);
          }
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          console.log(error)
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    sendUpdateAction(payload) {
      if (payload.action === 'selectCategory') {
        this.fetchCriteriaCategory(payload.value).then((response) => {
          this.fetchVerificationQuestions({
            criteriaCategoryId: response.id,
            limited: true,
          }).then((verificationQuestions) => {
            this.allVerificationQuestions = verificationQuestions;
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.statements.set_statement'),
                fields: this.statementAttributes,
                model: this.storedStatement,
                submitTitle: this.$t('app.statements.buttons.save'),
                cancelTitle: this.$t('app.statements.buttons.cancel'),
                modelName: 'statements',
                hasMultipleColumn: true,
              },
              on: {
                sendAction: this.sendUpdateAction,
                submit: this.updateStatement,
              },
              width: '1000px',
            });
          });
        });
      }
      if (payload.action === 'selectSubCategory') {
        this.fetchCriteriaCategory(payload.value).then((response) => {
          this.fetchVerificationQuestions({
            criteriaCategoryId: response.id,
            limited: true,
          }).then((verificationQuestions) => {
            this.allVerificationQuestions = verificationQuestions;
            this.$eventBus.showModal({
              bind: {
                is: GenericForm,
                title: this.$t('app.statements.set_statement'),
                fields: this.statementAttributes,
                model: this.storedStatement,
                submitTitle: this.$t('app.statements.buttons.save'),
                cancelTitle: this.$t('app.statements.buttons.cancel'),
                modelName: 'statements',
                hasMultipleColumn: true,
              },
              on: {
                sendAction: this.sendUpdateAction,
                submit: this.updateStatement,
              },
              width: '1000px',
            });
          });
        });
      }
    },
  },
  watch: {
    isSearch(newValue, oldValue) {
      // this.open = newValue
    },
  },
};
</script>

<style lang="scss" scoped>
.category-row {
  display: flex;
  align-items: center;
  padding-left: 0;
}
.zmdi-edit {
  margin-left: 30px;
  margin-right: 30px;
}
.action-row {
  display: flex;
  justify-content: flex-end;
}
.location-col {
  display: flex;
}
.array-span {
  background: var(--main-color);
  border-radius: 4px;
  color: #ffffff !important;
  font-size: 11px;
  padding: 3px 4px 3px 4px;
  margin-right: 10px;
  float: left;
  text-align: center;
}

.extra-icon {
  font-size: 19px;
}

.extra-icon.active{
  color: var(--main-color);
}

.ti-info{
  color: var(--main-color) !important;
  font-size: 19px !important;
}

.statement-row {
  display: flex;
  align-items: center;
}
.model-id, .model-name {
  float: left !important;
}
.action-button {
  cursor: pointer;
}

.add-question,
.add-category {
  cursor: pointer;
  margin-left: 40px;
  font-size: 14px;
  font-weight: 500;
}
.add-question {
  margin-left: 80px;
  margin-right: 80px;
}

.add-question:before,
.add-category:before {
  font: normal normal normal 14px/1 FontAwesome;
  left: 18px;
  content: "\f067";
  margin-right: 5px;
}

.paragraph {
  line-height: 14.5px !important;
}
.paragraph::after {
    font-size: 14.5px;
    content: "§";
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/StatementItem.vue